import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, AbstractControl } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { TprecmApiService } from 'src/modules/api';
import { tap, startWith, map, finalize } from 'rxjs/operators';
import { ProgramMaintenanceService } from '../program-maintenance.service';
import { Observable } from 'rxjs';

@Component({
   selector: 'program-tool-front-loader',
   templateUrl: './program-tool-front-loader.component.html',
   styleUrls: ['./program-tool-front-loader.component.scss']
})
export class ProgramToolFrontLoaderComponent implements OnInit {

   loading = false;
   toolFrontLoaderForm: UntypedFormGroup;
   engineers: any[];
   /** 
    * Hardcoded program type options
    */
   programTypeOptions = [{ value: 'MAJ', name: 'Major_PPO' }, { value: 'MNP', name: 'Major_No PPO' }, { value: 'MDC', name: 'Mid Cycle' }];
   filteredBIWEngineers$: Observable<any[]>;
   filteredDEIEngineers$: Observable<any[]>;
   filteredGAEEngineers$: Observable<any[]>;

   constructor(
      private readonly dialogRef: MatDialogRef<ProgramToolFrontLoaderComponent>,
      private readonly fb: UntypedFormBuilder,
      private readonly programMaintenanceService: ProgramMaintenanceService,
      private readonly tprecmService: TprecmApiService,
      private readonly toastr: ToastrService,
      @Inject(MAT_DIALOG_DATA) readonly data: any
   ) {
      this.toolFrontLoaderForm = this.fb.group({
         programType: ['', Validators.required],
         engineerBIW: ['',
            [
               (control: AbstractControl): { [key: string]: any } | null =>
                  control.value.id ? null : { 'noEngineerBIW': { value: control.value } },
               Validators.required
            ]],
         engineerDEI: ['',
            [
               (control: AbstractControl): { [key: string]: any } | null =>
                  control.value.id ? null : { 'noEngineerDEI': { value: control.value } },
               Validators.required
            ]],
         engineerGAE: ['',
            [
               (control: AbstractControl): { [key: string]: any } | null =>
                  control.value.id ? null : { 'noEngineerGAE': { value: control.value } },
               Validators.required
            ]]
      });
   }

   ngOnInit() {
      this.tprecmService.getEngineers().pipe(
         tap(res => {
            if (res) { this.engineers = res; }
         }),
         tap(() => {
            this.filteredBIWEngineers$ = this.setupEngineerFilter('BIW');
            this.filteredDEIEngineers$ = this.setupEngineerFilter('DEI');
            this.filteredGAEEngineers$ = this.setupEngineerFilter('GAE');
         })
      ).subscribe();
   }

   setupEngineerFilter(engineerType: string) {
      const ctrl = this.toolFrontLoaderForm.get(`engineer${engineerType}`);
      let result$ = Observable.create();
      if (ctrl) {
         result$ = ctrl.valueChanges.pipe(
            startWith(''),
            map(value => {
               const filterVal = (typeof value === 'string') ? value.toLowerCase() : '';
               return this.engineers
                  .filter(e => !!e.lastFirstName)
                  .filter(e => e.lastFirstName.toLowerCase().indexOf(filterVal) !== -1);
            })
         );
      }

      return result$;
   }

   displayEngineer(engineer) {
      return engineer && engineer.lastFirstName ? engineer.lastFirstName : '';
   }

   onCloseClick() {
      this.dialogRef.close();
   }

   onAddClick() {
      // Map the request body to the correct formats
      const body = this.toolFrontLoaderForm.value;
      Object.keys(body).forEach(el => {
         if (el.includes('engineer') && body[el] instanceof Object) {
            body[el] = body[el].id;
         }
      });
      let sopDateString = (this.data.sop) ? new Date(this.data.sop).toISOString() : '';
      sopDateString = sopDateString.slice(0, sopDateString.indexOf('T'));
      body['sop'] = sopDateString;
      body['programId'] = this.data.id;

      this.loading = true;
      this.programMaintenanceService.addToolTemplates(body)
         .pipe(finalize(() => this.loading = false))
         .subscribe(
            () => {
               this.toastr.success('The template tools were added successfully');
               this.dialogRef.close();
            }
         );
   }
}
